import { LogoutOutlined } from '@ant-design/icons';
import { Button, Modal } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { TitleModalLogout } from 'src/screens/auth/Styles';

type Props = {
  onOk: () => void;
  onCancel: () => void;
  fetching?: boolean;
  title: string;
};

export const LogoutModal: React.FC<Props> = ({ onOk, onCancel, fetching, title }) => {
  const { t } = useTranslation();
  return (
    <Modal
      open={true}
      title={
        <TitleModalLogout>
          <LogoutOutlined />
          <p>{title}</p>
        </TitleModalLogout>
      }
      onOk={onOk}
      onCancel={onCancel}
      footer={[
        <Button key="cancel" type="default" size="large" onClick={onCancel}>
          {t('buttons:cancel')}
        </Button>,
        <Button key="logout" size="large" onClick={onOk} danger loading={fetching}>
          {t('loginScreen:logout')}
        </Button>,
      ]}
      closable={true}
      maskClosable={false}
      transitionName="fade"
      width={400}
    >
      <p>{t('loginScreen:you_are_going_to_close')}</p>
    </Modal>
  );
};
